import React, { Component } from 'react';
import { Row, Col, TextField } from 'emerald-ui';
import PropTypes from 'prop-types';

class SignUpFormUserInfo extends Component {
  handleChange = (key) => (event) => {
    const value = event.target.value;
    this.props.handleFieldChange({ [key]: value });
  };

  render() {
    const { firstName = {}, lastName = {}, email = {}, phone = {} } = this.props;
    return (
      <Row>
        <Col xs={12} md={5}>
          <div className="sign-up-form-description">
            <p>Basic user information</p>
            <p>Enter your primary contact's basic information</p>
          </div>
        </Col>
        <Col xs={12} md={7}>
          <div className="sign-up-fields-section">
            <TextField
              id="lastName"
              shape="classic"
              placeholder="Doe"
              label="Last name"
              onChange={this.handleChange('lastName')}
              value={lastName.value || ''}
              error={lastName.displayErrors ? lastName.errorMsg : ''}
            />
          </div>
          <div className="sign-up-fields-section">
            <TextField
              id="firstName"
              shape="classic"
              placeholder="Jane"
              label="First name"
              onChange={this.handleChange('firstName')}
              value={firstName.value || ''}
              error={firstName.displayErrors ? firstName.errorMsg : ''}
            />
          </div>
          <div className="sign-up-fields-section">
            <TextField
              id="email"
              shape="classic"
              placeholder="janedoe@e-mail.com"
              label="Email address"
              onChange={this.handleChange('email')}
              value={email.value || ''}
              error={email.displayErrors ? email.errorMsg : ''}
            />
          </div>
          <div className="sign-up-fields-section">
            <TextField
              id="phone"
              shape="classic"
              placeholder="(333)333-3333"
              label="Phone"
              maxLength="14"
              onChange={this.handleChange('phone')}
              value={phone.value || ''}
              error={phone.displayErrors ? phone.errorMsg : ''}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

SignUpFormUserInfo.propTypes = {
  handleFieldChange: PropTypes.func,
};

SignUpFormUserInfo.defaultProps = {
  handleFieldChange: () => {},
};

export default SignUpFormUserInfo;



// WEBPACK FOOTER //
// ./src/components/SignUpFormUserInfo/SignUpFormUserInfo.js